<template>
  <div class="dashboardGrid">
    <div class="halfWithCard">
      <div class="cardSubTitle">De sista 5 klippen</div>
      <div class="tableWrapper">
        <el-timeline>
          <el-timeline-item timestamp="2019-11-15" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/youtube/vid-1.png" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Socialförsäkringen i siffror 2019</div>
                <div class="timelineCardContent">
                  <span>
                    <font-awesome-icon :icon="['far', 'eye']" class="iconTimeLine" />2.804
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-up']" class="iconTimeLine" />5
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-down']" class="iconTimeLine" />5
                  </span>
                  <span>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-10" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/youtube/vid-2.png" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">هذا الفلم يتوجه إلى الوافدين الجدد في السويد الذين يحصلون على</div>
                <div class="timelineCardContent">
                  <span>
                    <font-awesome-icon :icon="['far', 'eye']" class="iconTimeLine" />26.584
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-up']" class="iconTimeLine" />900
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-down']" class="iconTimeLine" />1
                  </span>
                  <span>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-05" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/youtube/vid-3.png" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Hur mycket kostar det att täcka barnets behov?</div>
                <div class="timelineCardContent">
                  <span>
                    <font-awesome-icon :icon="['far', 'eye']" class="iconTimeLine" />66.365
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-up']" class="iconTimeLine" />77
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-down']" class="iconTimeLine" />8
                  </span>
                  <span>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-01" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/youtube/vid-4.png" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Hej och välkommen till Försäkringskassan!</div>
                <div class="timelineCardContent">
                  <span>
                    <font-awesome-icon :icon="['far', 'eye']" class="iconTimeLine" />4.235
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-up']" class="iconTimeLine" />30
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-down']" class="iconTimeLine" />2
                  </span>
                  <span>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-10-15" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/youtube/vid-5.png" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Om du har en hörselnedsättning kan du...</div>
                <div class="timelineCardContent">
                  <span>
                    <font-awesome-icon :icon="['far', 'eye']" class="iconTimeLine" />1.244
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-up']" class="iconTimeLine" />15
                  </span>
                  <span>
                    <font-awesome-icon :icon="['far', 'thumbs-down']" class="iconTimeLine" />0
                  </span>
                  <span>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div class="cardBottomContainer">
          <a href="#" alt class="cardBottomLink channelColorFacebookText">Visa Mer Tweets</a>
        </div>
      </div>
    </div>
    <div class="halfWithCard" style="height: 500px;">
      <div class="cardSubTitle">Sista 5 klippen</div>
        <div class="tableWrapper">
          <table class="tableCard">
            <thead>
              <tr>
                <td>KLIPP</td>
                <td>TOTALT ANTAL VISNINGAR</td>
                <td>VISNINGAR ÖVER TID</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Så här loggar du in på Mina sidor med Mobilt BankID (mobil)...</td>
                <td>248.787</td>
                <td><div id="line1"></div></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Så här ansöker du om aktivitetsstöd, utvecklingsersättning och etableringsersättning...</td>
                <td>158.456</td>
                <td><div id="line2"></div></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Hur mycket kostar det att täcka barnets behov...</td>
                <td>61.642</td>
                <td><div id="line3"></div></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Så här ansöker du om sjukpenning...</td>
                <td>45.933</td>
                <td><div id="line4"></div></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
              <tr>
                <td>Personligt webbmöte (Textad version)...</td>
                <td>39.123</td>
                <td><div id="line5"></div></td>
                <td><font-awesome-icon :icon="['fas', 'external-link-alt']" /></td>
              </tr>
            </tbody>
          </table>
        <div class="cardBottomContainer"><a href="#" alt="" class="cardBottomLink channelColorFacebookText">Visa Mer</a></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    // ...
  },

  async mounted () {
    const line1 = {
      chart: {
        type: 'line',
        width: 150,
        height: 50,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [{
        data: [15, 75, 47, 65, 14, 2, 41, 54, 4, 27, 15]
      }],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    const line2 = {
      chart: {
        type: 'line',
        width: 150,
        height: 50,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [{
        data: [54, 4, 27, 15, 15, 75, 47, 65, 14, 2, 41]
      }],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    const line3 = {
      chart: {
        type: 'line',
        width: 150,
        height: 50,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [{
        data: [15, 5, 24, 5, 14, 2, 40, 54, 4, 27, 15]
      }],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    const line4 = {
      chart: {
        type: 'line',
        width: 150,
        height: 50,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [{
        data: [13, 14, 15, 16, 88, 2, 35, 16, 30, 8, 15]
      }],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    const line5 = {
      chart: {
        type: 'line',
        width: 150,
        height: 50,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [{
        data: [47, 65, 10, 7, 41, 54, 4, 27, 15, 15, 75]
      }],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return ''
            }
          }
        },
        marker: {
          show: false
        }
      }
    };

    new ApexCharts(document.querySelector('#line1'), line1).render();
    new ApexCharts(document.querySelector('#line2'), line2).render();
    new ApexCharts(document.querySelector('#line3'), line3).render();
    new ApexCharts(document.querySelector('#line4'), line4).render();
    new ApexCharts(document.querySelector('#line5'), line5).render();
  } 
}
</script>
